export default __webpack_public_path__ + "static/media/artemestLong.51f1bc5e.svg";